import { render, staticRenderFns } from "./CODdecline.vue?vue&type=template&id=5d9f206d&scoped=true"
import script from "./CODdecline.vue?vue&type=script&lang=js"
export * from "./CODdecline.vue?vue&type=script&lang=js"
import style0 from "./CODdecline.vue?vue&type=style&index=0&id=5d9f206d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f206d",
  null
  
)

export default component.exports